<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :style="style"
    :width="calculatedSize"
    :height="calculatedSize"
    :stroke="strokeVal"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid">
    <circle cx="50" cy="50" fill="none" stroke-width="6" r="24" stroke-dasharray="113.09733552923255 39.69911184307752">
      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
    </circle>
  </svg>
</template>

<script>
export default {
  props: ["backgroundColor", "size", "stroke"],
  computed: {
    style() {
      return "margin: auto; background: " + (this.backgroundColor || "inherit") + "; display: block";
    },
    calculatedSize() {
      return this.size ? this.size + "px" : "31px";
    },
    strokeVal() {
      return this.stroke ? this.stroke : "#689cc5";
    }
  }
};
</script>
